import isEqual from 'lodash/isEqual';

import { ContentTypes } from '@lumapps/content-types/types';

import { ContentLinkRef } from '../types';

const AVAILABLE_CONTENT_TYPES: string[] = [ContentTypes.PAGE, ContentTypes.NEWS, ContentTypes.CUSTOM];

export const isParentContentDisplayedInChildSite = (
    contentLinkRef: ContentLinkRef,
    displayContentInChildSite?: boolean,
    currentInstanceParentId?: string,
): boolean => {
    const {
        instance: { id: instanceId } = {},
        isV2Compatible,
        type: contentType = ContentTypes.CUSTOM,
    } = contentLinkRef;

    return Boolean(
        displayContentInChildSite &&
            instanceId &&
            currentInstanceParentId === instanceId &&
            !isEqual(isV2Compatible, false) &&
            AVAILABLE_CONTENT_TYPES.includes(contentType),
    );
};
